// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CourseModuleSettingsModuleId } from './courseModuleSettingsModuleId';
import type { CourseModuleSettingsSortIndex } from './courseModuleSettingsSortIndex';
import type { CourseModuleSettingsCorrector } from './courseModuleSettingsCorrector';
import type { CourseModuleSettingsAllowPartialSubmission } from './courseModuleSettingsAllowPartialSubmission';
import type { CourseModuleSettingsEcts } from './courseModuleSettingsEcts';
import type { CourseModuleSettingsLearningHours } from './courseModuleSettingsLearningHours';
import type { CourseModuleSettingsExamTaskIds } from './courseModuleSettingsExamTaskIds';

/**
 * Properties of a Module in a Course
 */
export interface CourseModuleSettings {
  moduleId?: CourseModuleSettingsModuleId;
  sortIndex?: CourseModuleSettingsSortIndex;
  corrector?: CourseModuleSettingsCorrector;
  allowPartialSubmission?: CourseModuleSettingsAllowPartialSubmission;
  ects?: CourseModuleSettingsEcts;
  learningHours?: CourseModuleSettingsLearningHours;
  examTaskIds?: CourseModuleSettingsExamTaskIds;
}
